import { Component, OnInit, Input } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import * as _ from 'lodash';

@Component({
	selector: 'ccp-crossdevice',
	templateUrl: './crossdevice.component.html',
	styleUrls: ['./crossdevice.component.scss']
})
export class CrossDeviceComponent implements OnInit {

	@Input() group: string;
	@Input() formArray: FormArray;

	constructor() { }

	ngOnInit() {
	}

	onCheckboxChange(e) {

		if (e.target.checked) {
			this.crossDeviceControl.value.push(e.target.value);
			this.crossDeviceControl.reset(_.uniq(this.crossDeviceControl.value));
		} else {
			this.checkAndRemoveCheckboxElementIfExist(e);
		}
	}

	checkAndRemoveCheckboxElementIfExist(e) {
		this.crossDeviceControl.value.forEach((item: FormControl, index) => {
			if (item == e.target.value) {
				this.crossDeviceControl.value.splice(index, 1);
				return;
			}
		});
	}

	get crossDeviceControl(): FormControl {
		return this.formArray.controls[this.group].get("crossDeviceTargeting");
	}

}
